import useTranslations from "hooks/useTranslations"

export const PrivacyPolicyLink = ({ text }) => {
  const { pdfPrivacyPolicyLink, subscribePrivacyPolicy2 } = useTranslations()

  return (
    <div className="mt-4 leading-4">
      <span className="text-xs text-zinc-700">{text} </span>
      <a
        className="underline"
        target="_blank"
        rel="noopener noreferrer"
        href={pdfPrivacyPolicyLink}
      >
        <span className="text-xs text-zinc-700">{subscribePrivacyPolicy2}</span>
      </a>
      {text === "" ? "" : "."}
    </div>
  )
}
